$(function () {
  var MAX_SIZE = 2 * 1024 * 1024; // 2 MB
  var $wrap = $('.logo-upload');
  var $input = $('#organization_logo');
  var $remove = $('#remove_logo');
  var $img = $wrap.find('.logo-upload__img');
  var $error = $wrap.find('.logo-upload__error');
  var hasOriginal = !!$wrap.data('original');
  var objectUrl = null;

  function showError(msg) {
    $error.text(msg).toggle(!!msg);
  }

  function releaseUrl() {
    if (objectUrl) {
      URL.revokeObjectURL(objectUrl);
      objectUrl = null;
    }
  }

  // Open file dialog (placeholder click or "Change")
  $wrap.on(
    'click',
    '.logo-upload__placeholder, .logo-upload__change',
    function () {
      $input.trigger('click');
    }
  );

  // File selected
  $input.on('change', function () {
    var file = this.files && this.files[0];
    showError('');

    if (!file) {
      return; // dialog cancelled: keep current state
    }
    if (!/^image\//.test(file.type)) {
      $input.val('');
      return showError('Please select an image file.');
    }
    if (file.size > MAX_SIZE) {
      $input.val('');
      return showError('The image must be smaller than 2 MB.');
    }

    releaseUrl();
    objectUrl = URL.createObjectURL(file);
    $img.attr('src', objectUrl);
    $remove.val('0');
    $wrap.addClass('is-filled');
  });

  // Remove
  $wrap.on('click', '.logo-upload__remove', function () {
    releaseUrl();
    $input.val('');
    $img.attr('src', '');
    $remove.val(hasOriginal ? '1' : '0'); // tell the server to delete the saved logo
    showError('');
    $wrap.removeClass('is-filled');
  });
});
